import { filter, get, includes } from "lodash";
import type { RootState } from "types/state";
import type { IraAccount } from "types/models";
import {
  recurringContributionSelector,
  payrollContributionSelector,
} from "store/selectors/contribution";

export const investmentAccountsSelector = (state: RootState): IraAccount[] => {
  return get(state, "accounts.iraAccounts", []);
};
export const activeInvestmentAccountsSelector = (
  state: RootState
): IraAccount[] => {
  const allAccounts = investmentAccountsSelector(state);
  const activeAccountState = "AccountActive";
  const activeAccounts = filter(allAccounts, (account) =>
    includes(account.lifecycleState, activeAccountState)
  );
  return activeAccounts;
};

export const recurringContributionAccountIdSelector = (state: RootState) => {
  const recurringContribution = recurringContributionSelector(state);
  return get(recurringContribution, "targetIraAccountId", null);
};

export const payrollContributionAccountIdSelector = (state: RootState) => {
  const payrollContribution = payrollContributionSelector(state);
  return get(payrollContribution, "accountId", null);
};
